module.exports = __webpack_public_path__ + "static/media/contact.16b4cb75.jpeg";